// store/modules/guests.js
export default {
  namespaced: true,
  state: {
    numberOfGuest: 1,
    guestCountSetting: {
      fix_guest_count: {
        status: false
      }
    },
    fullName: '',
    isCheckoutFormEmpty: true,
    trackRetakeClick: 0,
    pass: '',
    paymentAlert: false,
    fincodeToken: null,
    pmsCode: null,
    userRemarks: null,
    rsvNo: null,
    bookingPlanCode: null,
    roomNo: null,
  },
  mutations: {
    SET_BOOKING_PLAN_CODE(state, payload) {
      if (typeof payload === 'string' && payload.includes('|')) {
        const parts = payload.split('|');
        state.bookingPlanCode = parts[parts.length - 1].trim();
      } else {
        state.bookingPlanCode = payload;
      }
    },

    SET_RESERVATION_NO(state, payload) {
      state.rsvNo = payload;
    },

    SET_USER_REMARKS(state, payload) {
      state.userRemarks = payload;
    },

    SET_PMS_CODE(state, payload) {
      state.pmsCode = payload;
    },

    SET_TOKENIZED_CARD(state, payload) {
      state.fincodeToken = payload;
    },

    SET_PAYMENT_ALERT(state, payload) {
      state.paymentAlert = payload;
    },

    TRACK_RETAKE_CLICK(state) {
      state.trackRetakeClick++;
    },

    RESET_RETAKE_CLICK(state) {
      state.trackRetakeClick = 0;
    },

    SAVE_BOOKING_PASS(state, payload) {
      state.pass = payload
    },

    SAVE_NUMBER_OF_GUEST(state, payload) {
      state.numberOfGuest = payload
    },

    SAVE_FULL_NAME(state, payload) {
      state.fullName = payload;
    },

    GET_GUEST_COUNT_SETTING(state, payload) {
      state.guestCountSetting = { ...payload }
    },

    CHECK_IF_CHECKOUT_FORM_IS_EMPTY(state, payload) {
      state.isCheckoutFormEmpty = payload
    },

   SAVE_ROOM_NO(state, payload) {
      if (typeof payload === 'string' && payload.includes('|')) {
        state.roomNo = payload
          .split('|')
          .map(r => r.trim())
          .filter(r => r !== '');
      } else {
        state.roomNo = [payload];
      }
    }
  },
  actions: {
    // save the room number from the rsv - if the facility is on prem
    saveRoomNo({ commit }, payload) {
      commit('SAVE_ROOM_NO', payload);
    },

    //save the booking plan code alias meal plan code
    saveBookingPlanCode({ commit }, payload) {
      commit('SET_BOOKING_PLAN_CODE', payload);
    },

    // save the reservation no in checkin by phone
    saveRsvNo({ commit }, payload) {
      commit('SET_RESERVATION_NO', payload);
    },

    // save user remarks for meal reservation
    saveUserRemarks({ commit }, payload) {
      commit('SET_USER_REMARKS', payload);
    },

    // save pms code for meal reservation
    savePmsCode({ commit }, payload) {
      commit('SET_PMS_CODE', payload);
    },

    setTokenizedCard({ commit }, payload) {
      commit('SET_TOKENIZED_CARD', payload);
    },

    setPaymentAlert({ commit }, payload) {
      commit('SET_PAYMENT_ALERT', payload);
    },

    trackRetake({ commit }) {
      commit('TRACK_RETAKE_CLICK');
    },

    resetRetake({ commit }) {
      commit('RESET_RETAKE_CLICK');
    },

    saveNumberOfGuest({ commit }, payload) {
      commit('SAVE_NUMBER_OF_GUEST', payload)
    },

    saveFullName({ commit }, payload) {
      commit('SAVE_FULL_NAME', payload)
    },

    getGuestCount({ commit }, payload) {
      commit('GET_GUEST_COUNT_SETTING', payload)
    },

    setCheckoutFormEmpty({ commit }, payload) {
      commit('CHECK_IF_CHECKOUT_FORM_IS_EMPTY', payload)
    },

    setBookingPass({ commit }, payload) {
      commit('SAVE_BOOKING_PASS', payload)
    },
  },
  getters: {
    isCheckoutFormEmpty: (state) => {
      return state.isCheckoutFormEmpty;
    },
  }
};